<script>

    import { toast } from 'bulma-toast'
    import { userStore, chargesStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import ChargesService from '../$services/charges.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Select from '../$components/select.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonOpen from '../$components/button.open.svelte'
    import ChargesTotal from './component.charges.total.svelte'

    const categories = {
        overweight: { text: 'Sobrepeso', color: 'is-warning' },
        manual_guide: { text: 'Guía manual', color: 'is-info' },
        extended_zone: { text: 'Zona extendida', color: 'is-link' },
        canceled_guide: { text: 'Guía cancelada', color: 'is-danger' },
        balance_credit: { text: 'Abono de saldo', color: 'is-success' },
        promotion: { text: 'Promoción', color: 'is-primary' },
        other: { text: 'Otro', color: 'is-light' },
    }

    export let all = false
    export let type = null

    let query = {
        page: 0,
        find: null,
        type,
    }
    let metadata = {}
    let loading = false

    $: skeletonCols = all ? 10 : 9

    getCharges()

    $: if (type) query.type = type

    async function getCharges() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await ChargesService.getCharges(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.set(resp.data.charges)
        metadata = resp.data.metadata
    }

</script>

<Table
    items={ $chargesStore.length }
    total={ metadata.total }
    { loading }
    { skeletonCols }
    bind:metadata
    bind:page={ query.page }
    on:change={ getCharges }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ query.find } on:enter={ getCharges } />
            {#if !all && isPermission($adminStore, 'UsersView.Charge.Create')}
                <ButtonModal modalId="charge_create_modal" text="Agregar" icon="plus" />
            {/if}
        </div>
        <div class="header-actions">
            {#if !type}
                <Select bind:value={ query.type } on:change={ getCharges }
                    text="Tipo"
                    size="small"
                    options={[
                        {value: 'charge', text: 'Cargo'},
                        {value: 'refund', text: 'Reembolso'},
                    ]}
                />
            {/if}
            <Select bind:value={ query.status } on:change={ getCharges }
                text="Estatus de pago"
                size="small"
                options={[
                    {value: 'review', text: 'Revisión'},
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'paid', text: 'Pagado'},
                ]}
            />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            {#if all}
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        <span>Usuario</span>
                    </span>
                </th>
            {/if}
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-tag"></i></span>
                    <span>Tipo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-folder"></i></span>
                    <span>Categoría</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Monto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-file-alt"></i></span>
                    <span>Concepto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar-plus"></i></span>
                    <span>Registro</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-paper-plane"></i></span>
                    <span>Envío</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $chargesStore as charge, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                {#if all}
                    <td>
                        <div class="td-stack">
                            <div>{ charge.user.name }</div>
                            <small>{ charge.user.email }</small>
                        </div>
                    </td>
                {/if}
                <td>{ TranslateMethods.get(charge.status) }</td>
                <td>{ TranslateMethods.get(charge.type) }</td>
                <td>
                    {#if categories[charge.category]}
                        <span class="tag is-light { categories[charge.category].color }">{ categories[charge.category].text }</span>
                    {/if}
                </td>
                <td>{ NumeralMethods.cash(charge.amount) }</td>
                <td>{ charge.concept }</td>
                <td>{ DateMethods.dateTimeLarge(charge.created) }</td>
                <td>{ charge.shipment?.created ? DateMethods.dateTimeLarge(charge.shipment.created) : '' }</td>
                <td>
                    <ButtonOpen on:click={() => modalStore.open('charge', 'modal', charge)} />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
